// extracted by mini-css-extract-plugin
export default {"header":"header_header__7KOW5","container":"header_container__P-W5p","logoLink":"header_logoLink__8JwAa","logo":"header_logo__bJC3O","text":"header_text__kHdq5"};